import React from 'react';
import { useWallet } from '@/hooks/useWallet';
import Button from '@/components/ui/Button';

export const WalletButton: React.FC = () => {
  const { address, isConnected, isConnecting, connect, disconnect } = useWallet();

  const formatAddress = (addr: string) => {
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  if (isConnected && address) {
    return (
      <div className="flex items-center gap-2">
        <div className="ff-border px-3 py-2 bg-[#0f3460] text-pixel-sm">
          {formatAddress(address)}
        </div>
        <Button variant="secondary" size="sm" onClick={disconnect}>
          Disconnect
        </Button>
      </div>
    );
  }

  return (
    <Button
      variant="primary"
      size="md"
      onClick={connect}
      isLoading={isConnecting}
    >
      {isConnecting ? 'Connecting...' : 'Connect Wallet'}
    </Button>
  );
};

export default WalletButton;
